// @flow
import { prefixRoutes } from 'metaup/routing/routingUtils';
import { downloadPageRoutes } from './DownloadPage';

export function downloadRoutes() {
  return prefixRoutes('/download/', [
    downloadPageRoutes(),
  ]);
}
